import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Settings|Roles|Details|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSettingsRolesRenameDialog';
export type SPSettingsRolesRenameDialogLocNames =
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonConfirm`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}ErrorNameRequired`
	| `${LocNameStart}ErrorNameMaxLength`
	| `${LocNameStart}ErrorNameOnlySpaces`
	| `${LocNameStart}TitleDetails`;

export const spSettingsRolesRenameDialogLocs: LocDefs<SPSettingsRolesRenameDialogLocNames> = {
	SPSettingsRolesRenameDialogButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Core/Settings.Roles.Button.CancelRename',
		...sharedProperties,
	},
	SPSettingsRolesRenameDialogButtonConfirm: {
		defaultValue: 'Confirm',
		description: 'Confirm button',
		displayPath: `${pathStart}Confirm`,
		displayType: 'Button',
		legacyName: 'Core/Settings.Roles.Button.ConfirmRename',
		...sharedProperties,
	},
	SPSettingsRolesRenameDialogLabelName: {
		defaultValue: 'Name',
		description: 'Label for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Core/Settings.Roles.FieldLabel.RoleName',
		...sharedProperties,
	},
	SPSettingsRolesRenameDialogErrorNameRequired: {
		defaultValue: 'A role name is required',
		description: 'Error for: A role name is required.',
		displayPath: `${pathStart}Role Name Required`,
		displayType: 'Error',
		legacyName: 'Core/Settings.Roles.FieldError.NameRequired',
		...sharedProperties,
	},
	SPSettingsRolesRenameDialogErrorNameMaxLength: {
		defaultValue: 'A role name cannot be longer than 50 characters',
		description: 'Error for: role name max length.',
		displayPath: `${pathStart}Role Name Max Length`,
		displayType: 'Error',
		legacyName: 'Core/Settings.Roles.FieldError.NameMaxLength',
		...sharedProperties,
	},
	SPSettingsRolesRenameDialogErrorNameOnlySpaces: {
		defaultValue: 'The role name must not contain only spaces',
		description: 'Error for: role name only containing spaces.',
		displayPath: `${pathStart}Role Name Only Spaces`,
		displayType: 'Error',
		legacyName: 'Core/Settings.Roles.FieldError.OnlySpaces',
		...sharedProperties,
	},
	SPSettingsRolesRenameDialogTitleDetails: {
		defaultValue: 'Role Details',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		...sharedProperties,
	},
};

export type SPSettingsRolesRenameDialogLocType = LocMap<SPSettingsRolesRenameDialogLocNames>;
